import AppRouter from "./routes/AppRouter";
import { ManualProgramProvider } from "./context/ManualProgramContext";
import { MultiWeekProgramProvider } from "./context/MultiWeekProgramContext";
import AuthBootstrapProvider from "./auth/AuthBootstrapProvider";

export default function App() {
  return (
    <AuthBootstrapProvider>
      <ManualProgramProvider>
        <MultiWeekProgramProvider>
          <AppRouter />
        </MultiWeekProgramProvider>
      </ManualProgramProvider>
    </AuthBootstrapProvider>
  );
}
